var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409,275.8c-11.3,39.9-35.1,75.2-67.9,100.5-33.5,25.9-74.7,39.9-117.1,39.8-105.9,0-192-86.1-192-192S118.1,32.1,224,32.1c42.4-.1,83.6,13.9,117.1,39.8,19.5,15,36,33.7,48.5,55,1.1,1.9,1.4,4.2.8,6.3-1.2,4.2-5.7,6.7-9.9,5.4l-87.9-25.8c-8.5-2.5-17.4,2.4-19.9,10.8-2.5,8.5,2.4,17.4,10.8,19.9l136,40c1.2.3,2.4.6,3.6.6,8.8.5,16.4-6.3,16.9-15.1l8-144c0-.1,0-.2,0-.3.4-8.8-6.4-16.3-15.3-16.7-8.8-.4-16.3,6.4-16.7,15.3l-3.1,56.2c-.1,2.3-1.2,4.4-3,5.8-3.4,2.8-8.5,2.2-11.2-1.2C356.1,30.8,291.7,0,223.6,0,100,.2-.2,100.5,0,224.1c0,49.4,16.3,97.4,46.5,136.6,75.4,98.1,216.1,116.4,314.1,41,38.3-29.6,66.1-70.7,79.2-117.3.4-1.4.6-2.8.6-4.3,0-8.8-7.2-16-16-16-7.2,0-13.5,4.8-15.4,11.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.a40305923238b9d03a1da2c1f7410bb5.svg";
export { ForwardRef as ReactComponent };